// The date filter (O13/O18): a single date or a range, with quick buttons. The picked date is
// treated as "today" across the tab; a range covers from–to, and the "tomorrow" block is the day
// after the range.
import { DatePicker } from "antd";
import dayjs, { Dayjs } from "dayjs";
import React from "react";
import styles from "../index.module.scss";

const { RangePicker } = DatePicker;

export type OcRange = [Dayjs, Dayjs];

export const todayRange = (): OcRange => [dayjs().startOf("day"), dayjs().startOf("day")];

const presets = (): { label: string; value: OcRange }[] => {
  const t = dayjs().startOf("day");
  return [
    { label: "Today", value: [t, t] },
    { label: "Tomorrow", value: [t.add(1, "day"), t.add(1, "day")] },
    { label: "Yesterday", value: [t.subtract(1, "day"), t.subtract(1, "day")] },
    { label: "Last week", value: [t.subtract(6, "day"), t] },
    { label: "Next week", value: [t, t.add(6, "day")] },
  ];
};

export const rangeLabel = (r: OcRange): string => {
  const [a, b] = r;
  const t = dayjs().startOf("day");
  if (a.isSame(b, "day")) {
    if (a.isSame(t, "day")) return "Today";
    if (a.isSame(t.add(1, "day"), "day")) return "Tomorrow";
    if (a.isSame(t.subtract(1, "day"), "day")) return "Yesterday";
    return a.format("D MMM");
  }
  return `${a.format("D MMM")} – ${b.format("D MMM")}`;
};

const DateBar: React.FC<{ value: OcRange; onChange: (r: OcRange) => void }> = ({ value, onChange }) => (
  <div className={styles.dateBar}>
    {presets().map((p) => {
      const active = p.value[0].isSame(value[0], "day") && p.value[1].isSame(value[1], "day");
      return (
        <button
          key={p.label}
          type="button"
          className={active ? styles.presetActive : styles.preset}
          onClick={() => onChange(p.value)}
        >
          {p.label}
        </button>
      );
    })}
    <RangePicker
      size="small"
      allowClear={false}
      value={value}
      format="D MMM YYYY"
      onChange={(v) => v && v[0] && v[1] && onChange([v[0].startOf("day"), v[1].startOf("day")])}
    />
  </div>
);

export default DateBar;
